import { ComponentBread, ComponentHeader, StyledCreate } from "@components";
import { PATH_COUPON_LIST, PATH_CREATE_COUPON_FAMILY } from "@configs";
import { CouponForm } from "@modules";
import { useTranslation } from "react-i18next";

export const PageCreateCouponFamily = () => {
  const { t } = useTranslation();

  const data = [
    {
      title: <a href={PATH_COUPON_LIST}>{t("page.coupon_management")}</a>,
    },
    {
      title: <a href={"/"}>{t("page.selected_program_name")}</a>,
    },
    {
      title: <a href={PATH_CREATE_COUPON_FAMILY}>{t("page.create_coupon_family")}</a>,
    },
  ];

  return (
    <>
      <ComponentHeader title={t("page.create_coupon_family")} />
      <StyledCreate>
        <ComponentBread pages={data} />
        <CouponForm />
      </StyledCreate>
    </>
  );
};
